import React from 'react';
import './FilterChips.css';

/* Pills de FILTRO single-select con conteos (F3, crecimiento del kit exigido
   por Pedidos: "Cancelado (304)", "Pago por confirmar (6)").
   Es FILTRO (pill con violeta activo), no pestaña (subrayado) — la distinción
   firmada del brief §8. Click en el chip activo lo des-selecciona (vuelve a
   'todos') salvo que el caller pase una opción explícita de "todos".
   Fila con scroll horizontal siempre (ESTANDAR §13.5). */
export default function FilterChips({
  options = [],            // [{ id, label, count? }]
  value = null,            // id activo (null = ninguno/todos)
  onChange,
  allowClear = true,       // click en el activo → null
  ariaLabel = 'Filtros',
  className = '',
}) {
  return (
    <div className={`ui-filterchips${className ? ` ${className}` : ''}`} role="group" aria-label={ariaLabel}>
      {options.map((o) => {
        const isActive = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            className={`ui-filterchip${isActive ? ' is-active' : ''}`}
            aria-pressed={isActive}
            onClick={() => onChange?.(isActive && allowClear ? null : o.id)}
          >
            {o.label}
            {o.count != null && <span className="ui-filterchip-count">{o.count > 999 ? '999+' : o.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
